import { Toaster } from "@blueprintjs/core";

const AppToaster = Toaster.create({});

export default AppToaster;



// WEBPACK FOOTER //
// ./src/core/util/AppToaster.ts